import React from 'react'
import PropTypes from 'prop-types'

const NameField = ({ name, onChange }) => (
  <div className="field">
    <label style={{ fontSize: '16px' }}>Name</label>
    <input
      type="text"
      name="name"
      placeholder="Full name"
      value={name}
      onChange={onChange}
      required
    />
  </div>
)

NameField.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
}

export default NameField



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/AccountCompletionForm/NameField/index.js